<div class="container">
    <div class="row justify-content-between align-items-center">
        <div class="col-md-6">
            <div class="banner-caption">
                <h1><span>BajajCapital Reviews: 41+ Lakh Investors have trusted BajajCapital for 60+ Years with 51000+ Cr Assets under Advisory</span></h1>
                <h5><span>From mutual fund investment to retirement planning, from protection with insurance to investing for child's dreams, BajajCapital is the preferred choice for wealth management for generations. Our customers have constantly rated us No. 1.

                    Get a chance to be featured on our page.
                    
                    Write a review now.</span></h5>
                <a href="/customer-reviews#query-form" class="btn btn-primary">Get Featured</a>
               
            </div>
        </div>
        <div class="col-md-6 col-lg-5">
            <div id="reviewCarousel" class="tab-dots carousel slide pointer-event" data-ride="carousel" data-interval="4000">
                <a class="carousel-control-prev" href="#reviewCarousel" role="button" data-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#reviewCarousel" role="button" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                </a>
                <div class="carousel-inner">                    
                    <ng-container *ngFor="let arr of resultarr; let j = index">
                        <ng-container  *ngIf="arr.show_home_page === '' ">
                        <div [ngClass]="arr.showactiveclass == 1 ? 'carousel-item active' : 'carousel-item'"  >
                        <div class="review-caption card">
                            <!-- <img src="assets/images/img.png" alt=""> -->
                            <img [src]="arr.testomonial_images.image_1" alt="">
                            <div class="card-body">
                                <div class="intro">{{arr.name}}, {{arr.location}}</div>
                                <div class="review-description">
                                    <blockquote>
                                        <p>{{arr.description}}</p>  
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                </ng-container>
                    
                </div>                            
                <ol class="carousel-indicators" >
                <!-- <ng-container *ngFor="let dot of reviewsarr;let i = index" >
                    <li data-target="#reviewCarousel" [attr.data-slide-to] = "i" [ngClass]="i===0 ? 'active' : ''" *ngIf="dot.show_home_page == ''" (click)="registerGAScrollReview('Scroll Dots')"></li>
                </ng-container> -->
                    <!-- <li data-target="#reviewCarousel" data-slide-to="1"></li>
                    <li data-target="#reviewCarousel" data-slide-to="2"></li> -->
                </ol>
            </div>
        </div>
    </div>
</div>
